'use client';

import dynamic from 'next/dynamic';

/**
 * Client island that lazy-loads {@link Toaster} (`sonner` + `next-themes`) so it
 * stays out of a route's first-load bundle — the toaster only matters once a
 * `toast(...)` fires, which never happens on first paint. `ssr: false` keeps it
 * off the server render (a toast host has nothing to render until a client-side
 * toast is queued). Use this instead of importing `Toaster` directly in a Server
 * Component layout that just needs a render target for occasional toasts.
 */
export const LazyToaster = dynamic(
  () => import('./sonner').then(mod => mod.Toaster),
  { ssr: false },
);
